import React from 'react';
import { PropTypes } from 'prop-types';

const FieldContainer = ({ className, hasError, children, label }) => (
  <div
    className={`${className} ${hasError ? 'error' : ''} inspectlet-sensitive`}
  >
    {children}
    <label>{label}</label>
  </div>
);

FieldContainer.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  hasError: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

FieldContainer.defaultProps = {
  className: '',
  label: '',
  hasError: false,
};

export default FieldContainer;
